import { getLesson } from '@yandex-int/k-common/client/api/defs/get-lesson';
import { getPrepLessonsDetails } from '@yandex-int/k-common/client/api/defs/get-prep-lessons-details';
import { useQuery } from 'react-query';

export function useLessonQuery(lessonId?: string | number) {
    return useQuery(['getLesson', lessonId], () => getLesson(Number(lessonId)), {
        enabled: lessonId,
        staleTime: Infinity,
    });
}

export function useLessonDetailsQuery(courseId: number | null, lessonId: number | undefined) {
    return useQuery(
        ['getLessonDetailsQuery', courseId, lessonId],
        () => getPrepLessonsDetails(courseId!, [Number(lessonId)]),
        {
            enabled: Boolean(courseId && lessonId),
        }
    );
}
